import { render } from "./Prita.vue?vue&type=template&id=7f61bb60&scoped=true"
import script from "./Prita.vue?vue&type=script&lang=js"
export * from "./Prita.vue?vue&type=script&lang=js"

import "./Prita.vue?vue&type=style&index=0&id=7f61bb60&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f61bb60"]])

export default __exports__